/**
 * Подпись полосы прогресса Campaign Studio по виду задания. Через одну
 * полосу идут создание кампаний, групп, дубли и Apply CPP — общая подпись
 * «Campaign created» после смены CPP говорила о том, чего не было.
 */

import type { CsJobStatus } from "./types";

type Phrases = { running: string; done: string };

const BY_FLOW: Record<string, Phrases> = {
  create_campaign: { running: "Creating campaign…", done: "Campaign created" },
  bulk_campaign: { running: "Creating campaigns…", done: "Campaigns created" },
  create_ad_groups: { running: "Creating ad groups…", done: "Ad groups created" },
  duplicate: { running: "Duplicating campaign…", done: "Campaign duplicated" },
  apply_cpp: { running: "Applying custom product page…", done: "Custom product page applied" },
};

const FALLBACK: Phrases = { running: "Working…", done: "Done" };

export function jobStatusLabel(flow: string, status: CsJobStatus): string {
  const p = BY_FLOW[flow] ?? FALLBACK;
  if (status === "queued") return "Queued — waiting for slot";
  if (status === "running") return p.running;
  if (status === "completed") return p.done;
  if (status === "partially_failed") return "Some units failed";
  return "Job failed";
}
